export default "__VITE_ASSET__1Kq0HWDq__"